export default __webpack_public_path__ + "static/media/nav_detail_img_12.c17b2f99.jpg";